import ExcellentExport from 'excellentexport/excellentexport';

require('./stat-menu.component.scss');

class StatMenuController {
  constructor(CurrentFilterService, RouterService, PermissionService) {
    this.CurrentFilterService = CurrentFilterService;
    this.router = RouterService;
    this.permission = PermissionService;
  }

  get filter() {
    return this.CurrentFilterService.filter;
  }

  download($event) {
    ExcellentExport.excel($event.currentTarget, 'datatable');
    return true;
  }
}

export const StatMenuComponent = {
  template  : require('./stat-menu.component.html'),
  controller: StatMenuController,
};



// WEBPACK FOOTER //
// ./src/stat/stat-menu.component.js